import { useMemo } from 'react'

import ClientConfig from '../../types/local/clientConfig'
import { useProcessEnv } from '../ProcessEnvProvider'

export const useClientConfig = (): ClientConfig => {
  const env = useProcessEnv()
  const envConfig = useMemo(
    () => ({
      discoveryServiceUrl: env.REACT_APP_DISCOVERY_SERVICE_URL || '',
      isDocker: !!env.REACT_APP_DOCKER,
    }),
    [env.REACT_APP_DISCOVERY_SERVICE_URL, env.REACT_APP_DOCKER]
  )

  return envConfig
}
